import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58c18887&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=58c18887&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c18887",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c18887')) {
      api.createRecord('58c18887', component.options)
    } else {
      api.reload('58c18887', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=58c18887&scoped=true", function () {
      api.rerender('58c18887', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberNew/paymentPageConfig/index.vue"
export default component.exports